var map = {
	"./apple/btn_lg_sign-in.png": 1078,
	"./apple/btn_lg_sign-up.png": 1079,
	"./apple/btn_md_sign-in.png": 1080,
	"./apple/btn_md_sign-up.png": 1081,
	"./apple/btn_sm_sign-in.png": 1082,
	"./apple/btn_sm_sign-up.png": 1083,
	"./google/btn_lg_sign-in.png": 1084,
	"./google/btn_lg_sign-up.png": 1085,
	"./google/btn_md_sign-in.png": 1086,
	"./google/btn_md_sign-up.png": 1087,
	"./google/btn_sm_sign-in.png": 1088,
	"./google/btn_sm_sign-up.png": 1089,
	"./microsoft/btn_lg_sign-in.png": 1090,
	"./microsoft/btn_lg_sign-up.png": 1091,
	"./microsoft/btn_md_sign-in.png": 1092,
	"./microsoft/btn_md_sign-up.png": 1093,
	"./microsoft/btn_sm_sign-in.png": 1094,
	"./microsoft/btn_sm_sign-up.png": 1095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1077;